import React from 'react'
import moment from 'moment'

import s from './Date.scss'


const Date = ({ date, withMicrodata }) => (
  <div className={s.date}>
    {moment(date).format('MM/DD/YYYY')}
    {
      withMicrodata && (
        <span itemProp="datePublished" style={{ display: 'none' }}>{date}</span>
      )
    }
  </div>
)

export default Date
